package msw

import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.json.Json
import models.NewsItem

object MockData {
    val newsItems: List<NewsItem> = listOf(
        NewsItem(
            id = "msw-1",
            title = "[MSW Mock] Shohei Ohtani Traded to Lakers for LeBron James in Shocking Cross-Sport Deal",
            description = "In an unprecedented move, the Lakers have traded LeBron James to the Dodgers in exchange for Shohei Ohtani. NBA and MLB commissioners are reportedly confused.",
            link = "https://example.com/mock-1",
            source = "Mock Sports Network",
            publishedAt = "2026-04-13T08:30:00Z",
            category = "Trade",
            titleJa = "[MSW Mock] 大谷翔平、レブロン・ジェームズとのクロススポーツトレードでレイカーズへ",
            descriptionJa = "前代未聞の動き。レイカーズがレブロン・ジェームズをドジャースにトレードし、大谷翔平を獲得。NBAとMLBのコミッショナーは困惑している模様。",
            translationStatus = "completed",
            translatedAt = "2026-04-13T09:00:00Z",
            summaryJa = "ロサンゼルス・レイカーズは、レブロン・ジェームズをロサンゼルス・ドジャースへ放出し、大谷翔平を獲得するという前代未聞のクロススポーツトレードを成立させた。\n\nこのトレードは両リーグのコミッショナーを困惑させており、NBAとMLBの規約上の整合性について緊急協議が行われている。大谷はバスケットボール経験がないものの、レイカーズのフロントは「二刀流の適応力に期待している」とコメントした。\n\n専門家の間では、このトレードがサラリーキャップに与える影響や、今後のクロススポーツトレードの前例となる可能性について議論が続いている。",
            summaryStatus = "completed",
            summarizedAt = "2026-04-13T09:30:00Z"
        ),
        NewsItem(
            id = "msw-2",
            title = "[MSW Mock] Warriors Sign AI Robot as Starting Point Guard",
            description = "Golden State Warriors have signed an AI-powered basketball robot to a 4-year max contract. Steve Kerr says 'It never misses a three.'",
            link = "https://example.com/mock-2",
            source = "Mock Sports Network",
            publishedAt = "2026-04-12T15:45:00Z",
            category = "Signing",
            titleJa = "[MSW Mock] ウォリアーズ、AIロボットを先発PGとして契約",
            descriptionJa = "ゴールデンステート・ウォリアーズがAI搭載バスケロボットと4年マックス契約を締結。スティーブ・カーHCは「3Pを外さない」とコメント。",
            translationStatus = "completed",
            translatedAt = "2026-04-12T16:15:00Z",
            summaryStatus = "failed"
        ),
        NewsItem(
            id = "msw-3",
            title = "[MSW Mock] Celtics Trade Entire Bench for One Pizza Delivery Driver",
            description = "Boston Celtics have completed the most unusual trade in NBA history, sending their entire bench rotation to the Knicks for a pizza delivery driver from Brooklyn.",
            link = "https://example.com/mock-3",
            source = "Mock Sports Network",
            publishedAt = "2026-04-11T21:00:00Z",
            category = "Trade",
            titleJa = "[MSW Mock] セルティックス、ベンチ全員をピザ配達員1人とトレード",
            descriptionJa = "ボストン・セルティックスがNBA史上最も異例のトレードを成立。ベンチメンバー全員をニックスに送り、ブルックリンのピザ配達員を獲得した。",
            translationStatus = "completed",
            translatedAt = "2026-04-11T21:30:00Z"
        ),
        NewsItem(
            id = "msw-4",
            title = "[MSW Mock] Nuggets Sign Nikola Jokic's Horse to 10-Day Contract",
            description = "The Denver Nuggets have signed Nikola Jokic's beloved horse 'Dream' to a 10-day contract. The horse will reportedly play center during Jokic's rest days.",
            link = "https://example.com/mock-4",
            source = "Mock Sports Network",
            publishedAt = "2026-04-10T12:00:00Z",
            category = "Signing",
            titleJa = "[MSW Mock] ナゲッツ、ヨキッチの愛馬と10日間契約を締結",
            descriptionJa = "デンバー・ナゲッツがニコラ・ヨキッチの愛馬「ドリーム」と10日間契約を締結。ヨキッチの休養日にセンターとしてプレーする予定。",
            translationStatus = "completed",
            translatedAt = "2026-04-10T12:30:00Z"
        ),
        NewsItem(
            id = "msw-5",
            title = "[MSW Mock] NBA Announces Games Will Be Played on the Moon Starting 2027",
            description = "The NBA has officially announced that the 2027 All-Star Game will be held on the Moon. SpaceX will provide transportation for players and fans.",
            link = "https://example.com/mock-5",
            source = "Mock Sports Network",
            publishedAt = "2026-04-09T10:00:00Z",
            category = "Other",
            titleJa = "[MSW Mock] NBA、2027年から月面で試合開催を発表",
            descriptionJa = "NBAが2027年オールスターゲームを月面で開催することを正式発表。選手とファンの輸送はSpaceXが担当する。",
            translationStatus = "completed",
            translatedAt = "2026-04-09T10:30:00Z"
        ),
        NewsItem(
            id = "msw-6",
            title = "[MSW Mock] 76ers Trade Ben Simmons' Ghost for Three Future Draft Picks",
            description = "The Philadelphia 76ers have somehow traded the lingering memory of Ben Simmons to the Sacramento Kings for three future first-round picks.",
            link = "https://example.com/mock-6",
            source = "Mock Sports Network",
            publishedAt = "2026-04-08T18:30:00Z",
            category = "Trade",
            titleJa = null,
            descriptionJa = null,
            translationStatus = "pending",
            translatedAt = null
        )
    )

    private val json = Json {
        prettyPrint = false
        ignoreUnknownKeys = true
        // デフォルト値のフィールド（translationStatus="pending" 等）が JSON から
        // 欠落すると、non-null フィールド欠如で Apollo のパースが失敗する
        encodeDefaults = true
    }

    /** モックデータをwindowスコープに公開（MSWハンドラから参照するため） */
    fun publishToWindow() {
        val jsonString = json.encodeToString(ListSerializer(NewsItem.serializer()), newsItems)
        val parsed = kotlin.js.JSON.parse<dynamic>(jsonString)
        kotlinx.browser.window.asDynamic().__mswMockData = parsed
    }
}
